<template>
    <div    class="relative bg-white rounded-lg cursor-pointer ring-0 focus:outline-none focus:ring-1 focus:ring-blue-500"
            @click="toggleValue"
    >
        <div class="rounded-lg border border-gray-300 bg-white px-4 py-3 flex flex-row justify-around items-center">
            <span class="relative flex items-center bg-white mr-2">
                <label for="offline-select-all" class="sr-only">Button Toggle</label>
                <input id="offline-select-all" :checked="value" type="checkbox" name="offline-select-all" class="text-blue-600 focus:ring-blue-500 rounded cursor-pointer">
            </span>
            <span class="text-sm font-medium text-gray-900 hover:text-gray-700">
                <slot></slot>
            </span>
        </div>
        <!-- On: "border-indigo-500", Off: "border-transparent" -->
        <div    class="absolute inset-0 rounded-lg border-2 pointer-events-none"
                :class="value ? 'border-blue-500' : 'border-transparent'"
                aria-hidden="true"
        ></div>
    </div>
</template>

<script>
import {iconNamesMixin} from '@/mixins/IconNamesMixin';

export default {
    name: "ButtonCheckbox",
    mixins: [iconNamesMixin],
    components: {},
    model: {
        prop: 'value',
        event: 'update:value',
    },
    props: {
        value: {
            type: Boolean,
            default: false,
        },
    },
    data() {
        return {
            
        }
    },
    created() {
        
    },
    mounted() {
        
    },
    methods: {
        toggleValue() {
            this.$emit('update:value', !this.value)
        },
    },
    computed: {
        
    },
    watch: {
        
    },
}
</script>

<style scoped>

</style>